import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";

export const useRegularityPanel = () => {
    const { showError } = useContext(ToastContext);
    const { selectedEmployee } = useEmployeFilter();
    const [loader, setLoader] = useState(false);
    const [popupOpne, setPopupOpen] = useState({ show: false, data: null })
    const [showHistory, setShowHistory] = useState(false);
    const [defaultPuncJson] = useState([
        {
            title: "Punctuality",
            icon: "📈",
            value: [],
            valueLabel: "",
            progress: true
        },
        {
            title: "Timesheet",
            icon: "✅",
            value: [0],
            valueLabel: "",
            progress: true
        },
        {
            title: "WFH",
            icon: "🏠",
            value: 0,
            valueLabel: "",
            progress: false
        },
        {
            title: "Gate Pass",
            icon: "🎫",
            value: 0,
            valueLabel: "",
            progress: false
        },
        {
            title: "Leave",
            icon: "🛌",
            value: [],
            valueLabel: "",
            progress: false
        },
        {
            title: "Regular.",
            icon: "🧾",
            value: 0,
            valueLabel: "",
            progress: false
        },
        {
            title: "Unpunc.",
            icon: "⚠️",
            value: 0,
            valueLabel: "",
            progress: false
        },
        {
            title: "Critical Leave",
            icon: "⚠️",
            value: 0,
            valueLabel: "",
            progress: false
        },
    ])
    const [puncJson, setPuncJson] = useState(defaultPuncJson);

    useEffect(() => {
        selectedEmployee?.user_code && getRegularityData();
    }, [selectedEmployee])

    const getRegularityData = async () => {
        try {
            setLoader(true);
            const payload = {
                requested_user_code: selectedEmployee?.user_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETMYREGULARITYSUMMARY"), payload);
            if (res) {
                const punctuality = res?.body?.data?.punctuality_summary?.[0];
                const leaveData = res?.body?.data?.leave_summary;
                const otherPunctualityData = res?.body?.data?.streak_summary?.[0];
                let leave = [];
                // format leave data
                leaveData?.forEach((item) => {
                    const leaveObj = {
                        name: item?.leave_type_name,
                        leave_taken: item?.leave_taken,
                        total_leave: item?.leave_closing_balance,
                    }
                    if (item?.leave_taken !== 0 || item?.leave_opening_balance !== 0) {
                        leave.push(leaveObj);
                    }
                })
                leave = _.sortBy(leave, "name");

                let dataArray = [...defaultPuncJson];

                // set punctuality data
                const puncIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Punctuality" }));
                dataArray[puncIndex]["value"] = [punctuality?.unpunctual_percentage?.toFixed(2) || 0];
                dataArray[puncIndex]["valueLabel"] = `${punctuality?.unpunctual_percentage?.toFixed(2) ? punctuality?.unpunctual_percentage?.toFixed(2) + "%" : ""}`;

                // set punctuality data
                const timesheetIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Timesheet" }));
                dataArray[timesheetIndex]["value"] = [otherPunctualityData?.timesheet_accuracy_percent || 0];
                dataArray[timesheetIndex]["valueLabel"] = `${otherPunctualityData?.timesheet_accuracy_percent ? otherPunctualityData?.timesheet_accuracy_percent + "%" : ""}`;

                // set leave data
                const leaveIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Leave" }));
                dataArray[leaveIndex]["value"] = [((leave?.[0]?.leave_taken / leave?.[0]?.total_leave) * 100)?.toFixed(2) || 0, ((leave?.[1]?.leave_taken / leave?.[1]?.total_leave) * 100)?.toFixed(2) || 0];
                dataArray[leaveIndex]["valueLabel"] = `PL:${leave?.[0]?.leave_taken || 0} / SL:${leave?.[1]?.leave_taken || 0}`;

                // set WFH data
                const wfhIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "WFH" }));
                dataArray[wfhIndex]["value"] = otherPunctualityData?.wfh_count || 0;
                dataArray[wfhIndex]["valueLabel"] = otherPunctualityData?.wfh_count || "";

                // set gate pass data
                const gateIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Gate Pass" }));
                dataArray[gateIndex]["value"] = otherPunctualityData?.gate_pass_approved || 0;
                dataArray[gateIndex]["valueLabel"] = otherPunctualityData?.gate_pass_approved ? otherPunctualityData?.gate_pass_approved + " (" + (otherPunctualityData?.total_gatepass_hours ? otherPunctualityData?.total_gatepass_hours : "") + ")" : "";

                // set regularization data
                const regIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Regular." }));
                dataArray[regIndex]["value"] = otherPunctualityData?.regularize_count || 0;
                dataArray[regIndex]["valueLabel"] = String(otherPunctualityData?.regularize_count || "") || "";

                // set unpunctuality data
                const unpuncIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Unpunc." }));
                dataArray[unpuncIndex]["value"] = punctuality?.unpunctual_days || 0;
                dataArray[unpuncIndex]["valueLabel"] = punctuality?.unpunctual_days || "";

                // set regularization data
                const criticalIndex = _.indexOf(dataArray, _.findWhere(dataArray, { title: "Critical Leave" }));
                dataArray[criticalIndex]["value"] = otherPunctualityData?.critical_leave || 0;
                dataArray[criticalIndex]["valueLabel"] = String(otherPunctualityData?.critical_leave || "") || "";

                setPuncJson(dataArray)
                setLoader(false);
            }
        } catch (error) {
            console.error("Error getting regularity data: ", error);
            setLoader(false);
        }
    }

    // Get Attandance Leave data HTML
    const getAttandanceLeaveDetails = async () => {
        try {
            const payload = {
                "input_year": new Date().getFullYear(),
                "input_month": new Date().getMonth() + 1,
                "requested_user_code": selectedEmployee?.user_code,
                "emp_data": true
            }
            const res = await services.getInvokeRemote("POST", Urls("GETATTANDANCELEAVEDETAILS"), payload);
            if (res?.status === 200) {
                setPopupOpen({ show: true, data: res?.body?.data?.attendance_leave_html?.[0] });
            } else {
                showError("Error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error("Error getting regularity data: ", error);
        }
    }

    return useMemo(() => ({
        loader, popupOpne, setPopupOpen, showHistory, setShowHistory, selectedEmployee, getAttandanceLeaveDetails, puncJson
    }), [loader, popupOpne, setPopupOpen, showHistory, setShowHistory, selectedEmployee, getAttandanceLeaveDetails, puncJson])
}